import React, { useState } from "react";
import { DataGrid } from '@mui/x-data-grid';
import { Box, IconButton, Tooltip } from '@mui/material';
import { ReactComponent as DeleteIcon } from '../../../assets/icons/toursManagement/delete.svg';
import { ReactComponent as MapPreviewIcon } from '../../../assets/icons/toursManagement/map.svg';
import { ReactComponent as UpdateIcon } from '../../../assets/icons/toursManagement/update.svg';
import styles from '../../../components/missions/shuttle/toursManagementTable.module.css'; // Adjust the path as necessary
import Swal from "sweetalert2";


export default function RoadsRecorderTable({ records, onViewRecord, onDeleteRecord, onUpdateRecord }) {


  async function onEditRecord(recording) {

      console.log(recording);
    const { value: newName } = await Swal.fire({
      title: 'Edit Recording Name',
      input: 'text',
      inputLabel: 'Recording Name',
      inputValue: recording.recordName,
      showCancelButton: true,
      confirmButtonText: 'Update',
      cancelButtonText: 'Cancel',
      inputValidator: (value) => {
        if (!value) return "Name cannot be empty";
      }
    });

     if (newName && newName !== recording.recordName) {
      try {
        const ok = await onUpdateRecord(recording.id, { name: newName });
        if (ok) {
          Swal.fire('Updated!', 'The recording was updated.', 'success');
        } else {
          Swal.fire('Failed updating!', 'Could not update recording.', 'error');
        }
      } catch (error) {
        Swal.fire('Failed updating!', 'The recording failed to update.', 'error');
      }
    }
  }

  const rows = records.map((record, idx) => ({
    id: record.id,
    recordName: record.recordName,
    startTime: record.startTime,
    endTime: record.endTime,
    originalRecord: record,
    onViewRecord,
    onDeleteRecord,
    onEditRecord
  }));

  const columns = [
    {
      field: 'recordName',
      headerName: 'Record Name',
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      renderHeader: () => (
        <strong className={styles.header_text}>Record Name</strong>
      ),
    },
    {
      field: 'startTime',
      headerName: 'Start Time',
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      renderHeader: () => (
        <strong className={styles.header_text}>Start Time</strong>
      ),
    },
    {
      field: 'endTime',
      headerName: 'End Time',
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      renderHeader: () => (
        <strong className={styles.header_text}>End Time</strong>
      ),
    },
    {
      field: 'actions',
      headerName: 'Actions',
      flex: 1,
      sortable: false,
      headerAlign: 'center',
      align: 'center',
      renderHeader: () => (
        <strong className={styles.header_text}>Actions</strong>
      ),
      renderCell: (params) => (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            position: 'relative',
          }}
        >
          <Box
            sx={{
              position: 'absolute',
              left: 0,
              height: '70%',
              width: '1px',
              backgroundColor: '#ccc',
              top: '50%',
              transform: 'translateY(-50%)',
            }}
          />
          <Box sx={{ display: 'flex', justifyContent: 'space-between', flexGrow: 1, paddingLeft: '8px' }}>
            <IconButton
              onClick={() => params.row.onViewRecord(params.row.originalRecord)}
              size="large"
              title="View"
            >
              <MapPreviewIcon style={{ width: '25px', height: '25px', color: '#616e87' }} />
            </IconButton>
            <IconButton
              onClick={() => params.row.onDeleteRecord(params.row.originalRecord)}
              size="large"
              title="Delete"
            >
              <DeleteIcon style={{ width: '30px', height: '30px', color: '#d33' }} />
            </IconButton>

            <IconButton
              onClick={() => params.row.onEditRecord(params.row.originalRecord)}
              size="large"
              title="Delete"
            >
              <UpdateIcon style={{ width: '30px', height: '30px', fill: '#616e87' }} />
            </IconButton>


          </Box>
        </Box>
      ),
    },
  ];

  return (
    <Box
      sx={{
        height: window.innerHeight < 700 ? 400 : window.innerHeight < 900 ? 500 : 650,
        minWidth: 300,
        maxWidth: 1050,
      }}
    >
      <DataGrid
        rows={rows}
        columns={columns}
        pageSize={10}
        rowsPerPageOptions={[10]}
        disableSelectionOnClick
        isRowSelectable={() => false}
        disableColumnMenu
        getRowHeight={() => 'auto'}
        sx={{
          backgroundColor: 'white',
          '& .MuiDataGrid-iconButtonContainer ': {
            visibility: 'visible',
            width: '0 !important',
            position: 'relative',
            right: '1px !important',
            outline: 'none !important',
            pointerEvents: 'none !important'
          },
          "& .MuiDataGrid-row": {
            minHeight: '50px !important',
          },
          "& .MuiDataGrid-row:first-of-type": {
            marginTop: '8px'
          },
          "& .MuiDataGrid-columnHeaders": {
            zIndex: 1,
            borderBottom: '8px solid #F0F0F3 ',
            marginBottom: '8px',
            outline: 'none !important',
          },
          "&.MuiDataGrid-root .MuiDataGrid-columnHeader:focus, &.MuiDataGrid-root .MuiDataGrid-cell:focus": {
            outline: 'none !important'
          },
          '.MuiDataGrid-columnSeparator': {
            display: 'none !important',
          },
          '&.MuiDataGrid-root': {
            borderRadius: '8px',
            border: '1px solid  #F0F0F3'
          },
          '&.MuiDataGrid-root .MuiDataGrid-cell:focus-within, & .MuiDataGrid-cell:focus': {
            outline: 'none !important',
          },
        }}
      />
    </Box>
  );
}
